export default __webpack_public_path__ + "static/media/IMG_0286.ec705b7e.JPG";